import { render, staticRenderFns } from "./newprice.vue?vue&type=template&id=014df21b&scoped=true"
import script from "./newprice.vue?vue&type=script&lang=js"
export * from "./newprice.vue?vue&type=script&lang=js"
import style0 from "./newprice.vue?vue&type=style&index=0&id=014df21b&prod&scoped=true&lang=css"
import style1 from "./newprice.vue?vue&type=style&index=1&id=014df21b&prod&lang=css"
import style2 from "./newprice.vue?vue&type=style&index=2&id=014df21b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014df21b",
  null
  
)

export default component.exports